import i18next, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";

import common from "@/locales/en/common.json";

/**
 * English-only for now, but every user-facing string goes through `t()` from day
 * one (contract §0.6) — retrofitting i18n across a grown UI is the expensive way
 * to do this.
 *
 * Features ship their own namespace file at
 * `src/features/<name>/locales/en.json`; it is registered here under the
 * feature's directory name. The glob is lazy-tolerant on purpose: `features/leads`
 * is written by another module and may not exist yet.
 */
const featureLocales = import.meta.glob<{ default: Record<string, unknown> }>(
  "/src/features/*/locales/en.json",
  { eager: true },
);

const resources: Resource = { en: { common } };

for (const [path, mod] of Object.entries(featureLocales)) {
  const namespace = path.split("/")[3];
  if (!namespace) continue;
  (resources.en as Record<string, unknown>)[namespace] = mod.default;
}

export const SUPPORTED_LOCALES = ["en"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

void i18next.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  defaultNS: "common",
  ns: Object.keys(resources.en ?? {}),
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const i18n = i18next;
